// Topwords copy/top-words/src/components/Menu.js
import React from 'react';
import './Menu.css';
import { useTranslation } from 'react-i18next';
import AdUnit from './AdUnit';

const getOS = () => {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

  if (iosPlatforms.indexOf(platform) !== -1 || (userAgent.includes("Mac") && "ontouchend" in document)) {
    return 'iOS';
  }
  
  if (/Android/.test(userAgent)) {
    return 'Android';
  }
  
  return 'Android'; 
};

function Menu({ onClose, onNavigate, isLoggedIn, userIsAnon, onGoogleLogin, onLogout, userName, onHome }) {
  const { t } = useTranslation();
  const userOS = getOS();

  const otherGames = [
    {
      id: "wordly",
      name: t('game_wordly_name'),
      iosUrl: "https://apps.apple.com/us/app/worddaily-guess-the-word/id6480531830",
      androidUrl: "https://play.google.com/store/apps/details?id=com.roghangames.wordle"
    },
    {
      id: "connections",
      name: t('game_connections_name'),
      iosUrl: "https://apps.apple.com/us/app/connections-game-word-match/id6476014083",
      androidUrl: "https://play.google.com/store/apps/details?id=com.roghangames.conexo"
    }
  ];

  return (
    <div className="menu-overlay" onClick={onClose}>
      <div className="menu-content" onClick={(e) => e.stopPropagation()}>
        <button className="menu-close-button" onClick={onClose}>×</button>
        <h2>Top 5 Game</h2>

        {isLoggedIn ? (
          <div className="user-profile-section logged-in">
            <p className="welcome-message">{t('welcome', { name: userName || t('logged_in_user') })}</p>
            <button onClick={onLogout} className="logout-button">{t('logout')}</button>
          </div>
        ) : (
          <nav className="menu-nav">
            {userIsAnon && (
              <button onClick={onGoogleLogin} className="google-login-button">
                {t('login_google')}
              </button>
            )}
          </nav>
        )}
        
        <hr className="menu-separator" />

        <nav className="menu-nav">
          {/* --- NOVO BOTÃO AQUI --- */}
          <button onClick={onHome} className="home-nav-button">{t('back_to_home')}</button>
          {/* ----------------------- */}
          
          <button onClick={() => onNavigate('how-to-play')}>{t('how_to_play')}</button>
          <button onClick={() => onNavigate('faq')}>{t('faq')}</button>
          <button onClick={() => onNavigate('guides')}>{t('guides')}</button>
          <button onClick={() => onNavigate('categories')}>{t('categories')}</button>
          <button onClick={() => onNavigate('updates')}>{t('updates')}</button>
          <button onClick={() => onNavigate('about')}>{t('about_us')}</button>
          <button onClick={() => onNavigate('contact')}>{t('contact_us')}</button>
          <button onClick={() => onNavigate('privacy')}>{t('privacy_policy')}</button>
          <button onClick={() => onNavigate('terms')}>{t('terms_of_service')}</button>
        </nav>

        <hr className="menu-separator" />
        <h3 className="more-games-title">{t('more_games')}</h3>

        <div className="menu-nav">
          {otherGames.map(game => {
            const url = userOS === 'iOS' ? game.iosUrl : game.androidUrl;
            return (
              <a 
                key={game.id} 
                href={url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="game-link"
              >
                {game.name}
              </a>
            );
          })}
        </div>

        <hr className="menu-separator" />
        <div className="menu-ad-slot">
          <AdUnit slot="3144142815" />
        </div>
      </div>
    </div>
  );
}

export default Menu;
